import { render, staticRenderFns } from "./SmsForwarderInfo.vue?vue&type=template&id=32ad159d&scoped=true&"
import script from "./SmsForwarderInfo.vue?vue&type=script&lang=js&"
export * from "./SmsForwarderInfo.vue?vue&type=script&lang=js&"
import style0 from "./SmsForwarderInfo.vue?vue&type=style&index=0&id=32ad159d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ad159d",
  null
  
)

export default component.exports